import React from 'react';
import ReactDOM from 'react-dom';

const Notification = ({ message }) => {
  return ReactDOM.createPortal(
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        style={{ animation: 'fadeIn 0.5s ease-in-out' }}
        className="bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 px-6 py-4 rounded-lg shadow-lg"
      >
        <p className="text-gray-900 dark:text-white text-xl font-semibold">
          {message}
        </p>
      </div>
    </div>,
    document.body
  );
};

export default Notification;
